import { useContext } from 'react';
import { UserContext } from '@providers/UserProvider/UserProvider';
import { ArkestroLogo } from './ArkestroLogo';
import styles from './logo.module.scss';

interface LogoImageProps {
  hidden?: boolean;
}

export const CustomerLogo = ({ hidden = false }: LogoImageProps) => {
  const { company } = useContext(UserContext) || {};
  const useWordmark = !!company?.wordmark_url;

  if (!useWordmark && hidden) return null;

  return (
    useWordmark ? (
      <div style={{ height: 65, position: 'relative', width: 150 }}>
        <img
          alt={company?.name || 'Company Logo'}
          className={styles.customerLogoImage}
          data-testid='logo-image'
          src={company?.wordmark_url as string}
        />
      </div>
    ) : (
      // Remove the padding to avoid extra space in the header when using the Arkestro logo
      <ArkestroLogo dark style={{ padding: 0 }} />
    )
  );
};
